import { navigate, RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';

import Button from '../../../../components/Button';
import DatePicker from '../../../../components/DatePicker';
import { FormConsumer, FormProvider, IFormAttributes } from '../../../../components/Forms';
import { IAdminClubActions } from '../../../../store/admin/clubs/actions';
import { ICreateSeasonForm } from '../../Settings/ClubSettings/SeasonsSection/NewSeason/NewSeason';

interface IState {
  invalidClub: boolean;
  invalidClubMessage: string;
  invalidSeason: boolean;
  invalidSeasonMessage: string;
}

interface IProps extends RouteComponentProps {
  actions: { adminClubs: IAdminClubActions };
  clubId: number;
}

class ClubSeasonDates extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      invalidClub: false,
      invalidClubMessage: '',
      invalidSeason: false,
      invalidSeasonMessage: ''
    };
  }

  public async componentWillMount(): Promise<any> {
    const response = await this.props.actions.adminClubs.get(this.props.clubId);
    if (response.errors) {
      setTimeout(navigate.bind(this, `/staff/club/create/info`));
    }
  }

  public onCancel = (): void => {
    navigate(`/login`);
  };

  public onSubmit = async (data: ICreateSeasonForm) => {
    const { clubId } = this.props;
    const response = await this.props.actions.adminClubs.createSeason(data, clubId);

    if (response.errors && (response.errors.club || response.errors.season)) {
      if (response.errors.club) {
        this.setState({
          invalidClub: true,
          invalidClubMessage: response.errors.club.msg || ''
        });
        navigate(`/staff/club/create/info`);
      }
      if (response.errors.season) {
        this.setState({
          invalidSeason: true,
          invalidSeasonMessage: response.errors.season.msg || ''
        });
      }
    } else {
      navigate(`/staff/club/create/${clubId}/complete`);
    }
  };

  public render(): JSX.Element {
    return (
      <div>
        <FormProvider
          defaultValues={{}}
          onSubmit={this.onSubmit}
          validations={{
            seasonEnd: ['required', 'date'],
            seasonStart: ['required', 'date']
          }}
        >
          <FormConsumer>
            {({ values, formActions: { setValue }, errors }: IFormAttributes) => (
              <div className="season-dates form">
                <h1 className="season-dates__title override">SELECT YOUR SEASON DATES</h1>
                <p className="help-text">Don't worry, you can always change the dates later.</p>
                <div className="dates-wrapper">
                  <DatePicker
                    id="season-start"
                    label="SEASON STARTS"
                    placeholder="01/01/2019"
                    value={values.seasonStart ? values.seasonStart : ''}
                    onChange={setValue('seasonStart')}
                    onError={setValue('seasonStart')}
                  />
                  <h2 className="big-text">THRU</h2>
                  <DatePicker
                    id="season-end"
                    label="SEASON ENDS"
                    placeholder="12/31/2020"
                    minDate={values.seasonStart}
                    value={values.seasonEnd ? values.seasonEnd : ''}
                    onChange={setValue('seasonEnd')}
                    onError={setValue('seasonEnd')}
                  />
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={errors.FORM}
                  type="submit"
                  className="season-dates__next-button button--shadow"
                  size="large"
                >
                  NEXT
                </Button>
              </div>
            )}
          </FormConsumer>
        </FormProvider>
      </div>
    );
  }
}

export { ClubSeasonDates };
